import { render, staticRenderFns } from "./AdminBannerMedias.vue?vue&type=template&id=2d90315f&"
import script from "./AdminBannerMedias.vue?vue&type=script&lang=js&"
export * from "./AdminBannerMedias.vue?vue&type=script&lang=js&"
import style0 from "./AdminBannerMedias.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports